import { useEffect } from "react";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setRedirectUrl } from "store";

const AppRedirectionWrapper = (props: { children: any }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const redirectTo: any = router.query.redirect;

  useEffect(() => {
    (async () => {
      if (redirectTo !== "" && redirectTo) {
        let validApps = process.env.NEXT_PUBLIC_BIDDER_URL;
        if (validApps && validApps.length > 0) {
          let currentAppUrl = validApps.includes(redirectTo);
          if (currentAppUrl) {
            dispatch(setRedirectUrl(redirectTo));
          } else {
            dispatch(setRedirectUrl("/"));
          }
        }
      } else {
        console.log("redirectTo-Empty-dont-do-anything", redirectTo);
        // dispatch(setRedirectAppUrl("/"));
      }
    })();
  }, [redirectTo]);

  return props.children;
};

export default AppRedirectionWrapper;
